export let config = {
  baseUrl: "https://blog.minikubes.com/api/",
  imgBaseUrl: "https://blog.minikubes.com/",
};

export let contactFormConfig = {
  baseUrl: "https://payment-router-backend.minikubes.com/form/gattaca-genomics/contact-us",
};
